console.clear();
var { isMobile, isDesktop } = require("./lib/breakpoints");
var { COLORS, makeTranslate, formatStyle, wrapText } = require("./lib/helpers");

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var fmtComma = s => s.toLocaleString().replace(/\.0+$/, "");

// Render a column chart.
module.exports = function(config) {
  // Setup chart container
  var { labelColumn, valueColumn } = config;

  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 9;
  var valueGap = 3;


  var margins = {
    top: 12,
    right: 5,
    bottom: 20,
    left: 42
  };

  // if(isMobile.matches) margins.top = 22;

  var roundTicksFactor = 5;

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight =
    Math.ceil((config.width * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");


  chartWrapper.append("h3")
                  .text("Difference between proposal acceptance rates for men and women (in percentage points)");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 scale objects.
  var xScale = d3
    .scaleBand()
    .range([0, chartWidth])
    .round(true)
    .padding(0.1)
    .domain(config.data.map(d => d[labelColumn]));

  var floors = config.data.map(
    d => Math.floor(d[valueColumn] / roundTicksFactor) * roundTicksFactor
  );

  var min = Math.min(...floors);

  if (min > 0) {
    min = 0;
  }

  var ceilings = config.data.map(
    d => Math.ceil(d[valueColumn] / roundTicksFactor) * roundTicksFactor
  );

  var max = Math.max(...ceilings);

  // if(isMobile.matches) min = -2.5

  var yScale = d3
    .scaleLinear()
    .domain([-15, max])
    .range([chartHeight, 0]);

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .tickValues([2002, 2005, 2010, 2015, 2020])

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .tickValues([5, 0,-5,-10, -15])
    .tickFormat(d => d + " pts");

  // Render axes to chart.
  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement
    .append("g")
    .attr("class", "y axis")
    .call(yAxis);

  // Render grid to chart.

  chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxis
        .tickSize(-chartWidth, 0)
        .tickFormat("")
    );

  // Render bars to chart.
  chartElement
    .append("g")
    .attr("class", "bars")
    .selectAll("rect")
    .data(config.data)
    .enter()
    .append("rect")
    .attr("x", d => xScale(d[labelColumn]))
    .attr("y", d => (d[valueColumn] < 0 ? yScale(0) : yScale(d[valueColumn])))
    .attr("width", xScale.bandwidth())
    .attr("height", d =>
      d[valueColumn] < 0
        ? yScale(d[valueColumn]) - yScale(0)
        : yScale(0) - yScale(d[valueColumn])
    )
    .attr("class", function(d) {
      return "bar bar-" + d[labelColumn];
    })
    .attr("fill", d=>
      d[valueColumn] > 0
        ? `${COLORS.teal4}`
        : `${COLORS.red4}`
    );

  // Render 0 value line.
  if (min < 0) {
    chartElement
      .append("line")
      .attr("class", "zero-line")
      .attr("x1", 0)
      .attr("x2", chartWidth)
      .attr("y1", yScale(0))
      .attr("y2", yScale(0));
  }


  if(isMobile.matches) {
    chartElement.append("g")
                .attr('class', "annotation")
                .attr("transform", makeTranslate(xScale(2015)+xScale.bandwidth()/2,yScale(0.72)-17))
                .append("text")
                .attr("text-anchor", "middle")
                // .attr("dominant-baseline", "hanging")
                .text("In 2018, the acceptance rate was higher for proposals led by women for the first time.")
                .call(wrapText,215,12);

  } else {
      chartElement.append("g")
                  .attr('class', "annotation")
                  .attr("transform", makeTranslate(xScale(2018),yScale(0.72)-30))
                  .append("text")
                  .attr("text-anchor", "middle")
                  // .attr("dominant-baseline", "hanging")
                  .text("In 2018, the acceptance rate was higher for proposals led by women for the first time.")
                  .call(wrapText,215,12);
  }

  chartElement.append("g")
                  .attr('class', "annotation")
                  .attr("transform", makeTranslate(xScale(2002),yScale(-11.1)+5))
                  .append("text")
                  .attr("text-anchor", "start")
                  .attr("dominant-baseline", "hanging")
                  .text("In 2003, 25% of proposals led by men were accepted, compared with only 14% led by women, a gap of 11 points.")
                  .call(wrapText,215,12);

  


  if(isDesktop.matches){
      // Render bar values.
      chartElement
        .append("g")
        .attr("class", "value")
        .selectAll("text")
        .data(config.data)
        .enter()
        .append("text")
        .text(d => d[valueColumn].toFixed(1))
        .attr("x", d => xScale(d[labelColumn]) + xScale.bandwidth() / 2)
        .attr("y", d => yScale(d[valueColumn]))
        .attr("dy", function(d) {
          var textHeight = this.getBBox().height;
          var $this = d3.select(this);
          var barHeight = 0;

          if (d[valueColumn] < 0) {
            barHeight = yScale(d[valueColumn]) - yScale(0);

            if (textHeight + valueGap * 2 < barHeight) {
              $this.classed("in", true);
              return -(textHeight - valueGap /2);
            } else {
              $this.classed("out", true);
              return textHeight + valueGap;
            }
          } else {
            barHeight = yScale(0) - yScale(d[valueColumn]);

            if (textHeight + valueGap * 2 < barHeight) {
              $this.classed("in", true);
              return textHeight + valueGap;
            } else {
              $this.classed("out", true);
              return -(textHeight) +8;
            }
          }
        })
        .attr("text-anchor", "middle");
  }

};
